export const ROUTES = {
  dashboard: "/dashboard",
  customer: "/customer",
  login: "/login",
  GuideTopicsPage: "/guides",
  GuideTopicPage: "/topic",
  GuideVideoPage: "/video",
  CommunicationPage: "/communication"
}
